import React, { useState } from 'react'
import InputGroup from '../../EmailSubscriptionCenter/SignIn/InputGroup.jsx'
import {
  postResetPassword,
  putResetPassword,
} from '../../SelfService/Data/SelfServiceDataSource.js'
import {
  CHANGE_PASSWORD_SUCCESS,
  PASSWORD_MODE,
} from '../Helpers/LoginHelper.js'
import NewUser from '../Static/NewUser.jsx'
import PasswordValidator from './PasswordValidator/PasswordValidator.jsx'

function ChangePassword({
  handleDisplayChange,
  changePasswordData,
  passwordMode,
  loginInputHook,
  showNewUser = false,
}) {
  const _currentPassword =
    changePasswordData && changePasswordData.currentPassword

  const RESPONSE_CODES = {
    INVALID_CURRENT_PASSWORD: '7006-4033',
    INVALID_NEW_PASSWORD: '7006-4034',
    INVALID_NEW_PASSWORD_2: '7005-4034',
    INVALID_TOKEN: '7006-1014',
    SSO_LOCKED: '7006-4036',
  }

  const _passwordMode = passwordMode || PASSWORD_MODE.TEMP_PASSWORD

  const [formValidation, setFormValidation] = useState({
    'current-password': {
      error: false,
      errorMessage: '',
    },
    'login-new-password': {
      error: false,
      errorMessage: '',
    },
    'login-confirm-new-password': {
      error: false,
      errorMessage: 'Password error',
    },
  })

  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [username] = loginInputHook
  const [passwordValid, setPasswordValid] = useState(true)
  const [currentPassword, setCurrentPassword] = useState('')
  const [showPasswordValidator, setShowPasswordValidator] = useState(false)

  const onChangeNewPassword = (event) => {
    const _val = event?.target?.value?.replace(/[\\"]/g, '')
    setShowPasswordValidator(!!_val)

    setNewPassword(_val)
  }

  const onChangeConfirmPassword = (event) => {
    setConfirmPassword(event?.target?.value?.replace(/[\\"]/g, ''))
  }

  const onChangeCurrentPassword = (event) => {
    setCurrentPassword(event?.target?.value?.replace(/[\\"]/g, ''))
    const _formValidation = { ...formValidation }
    _formValidation['current-password'].error = false
    setFormValidation(_formValidation)
  }

  const submitChangePassword = async () => {
    if (
      passwordMode === PASSWORD_MODE.CHANGE_PASSWORD_LOGGED_IN &&
      !currentPassword
    ) {
      const _formValidation = { ...formValidation }
      _formValidation['current-password'].error = true
      _formValidation['current-password'].errorMessage = 'Enter your password'
      setFormValidation(_formValidation)
    } else if (newPassword !== confirmPassword) {
      const _formValidation = { ...formValidation }
      _formValidation['login-confirm-new-password'].error = true
      _formValidation['login-confirm-new-password'].errorMessage =
        'Passwords do not match'
      setFormValidation(_formValidation)
    } else if (!passwordValid) {
      //console.log("CANT SUBMIT PASSWORD NOT VALID")
    } else {
      const _formValidation = { ...formValidation }
      _formValidation['login-confirm-new-password'].error = false
      setFormValidation(_formValidation)
      const data = await makeServiceCall()
      if (data.error && data.error.details) {
        handleError(data.error.details.code, data)
      } else {
        handleDisplayChange(CHANGE_PASSWORD_SUCCESS, {
          newPassword: newPassword,
        })
      }
      //
    }
  }

  const makeServiceCall = async () => {
    if (_passwordMode === PASSWORD_MODE.TEMP_PASSWORD) {
      const data = {
        currentPassword: _currentPassword,
        newPassword: newPassword,
      }

      return putResetPassword(data, true)
    } else if (_passwordMode === PASSWORD_MODE.CHANGE_PASSWORD_LOGGED_IN) {
      const data = {
        currentPassword: currentPassword,
        newPassword: newPassword,
      }
      return putResetPassword(data, false)
    } else if (passwordMode === PASSWORD_MODE.FORGOT_PASSWORD_CHANGE) {
      const data = {
        newPassword: newPassword,
      }
      // Loader.start()
      return postResetPassword(data)
    }
  }

  const handleError = (errorCode, data) => {
    const _formValidation = { ...formValidation }
    switch (errorCode) {
      case RESPONSE_CODES.INVALID_CURRENT_PASSWORD:
        _formValidation['current-password'].error = true
        _formValidation['current-password'].errorMessage =
          'The password you entered is incorrect. Please try again.'
        setFormValidation(_formValidation)
        break
      case RESPONSE_CODES.INVALID_NEW_PASSWORD:
      case RESPONSE_CODES.INVALID_NEW_PASSWORD_2:
        _formValidation['login-confirm-new-password'].error = true
        _formValidation['login-confirm-new-password'].errorMessage =
          'Please enter a valid password. Your password cannot  match your most recent password, cannot contain the word "password" or any variation of it and cannot be too common.'
        setFormValidation(_formValidation)
        break
      case RESPONSE_CODES.INVALID_TOKEN:
        // MessageHandler.showDefaultError("");
        break
      case RESPONSE_CODES.SSO_LOCKED:
        // Logout.logoutWithRedirect("/login?locked=true")
        break
      default:
        _formValidation['login-confirm-new-password'].error = true
        _formValidation['login-confirm-new-password'].errorMessage =
          data && data.error && data.error.details && data.error.details.message
        setFormValidation(_formValidation)
    }
  }

  function onValidatePassword(valid) {
    setPasswordValid(valid)
  }

  return (
    <div data-analytics-login-step="Change Password">
      <div className="Grid">
        <div className="u-sizeFull u-lg-after1of12 u-lg-size5of12 Content u-marginBottom6gu u-lg-marginBottom0">
          <fieldset>
            {passwordMode === PASSWORD_MODE.CHANGE_PASSWORD_LOGGED_IN && (
              <InputGroup
                formValidation={formValidation}
                fieldName="current-password"
                fieldId="current-password"
                label="Current password"
                handleInputChange={onChangeCurrentPassword}
                compact={false}
                type="password"
                defaultValue={currentPassword}
                maskedValue={currentPassword}
              />
            )}

            <InputGroup
              formValidation={formValidation}
              fieldName="login-new-password"
              fieldId="login-new-password"
              label="New password"
              handleInputChange={onChangeNewPassword}
              compact={false}
              type="password"
              defaultValue={newPassword}
              maskedValue={newPassword}
            />
            {showPasswordValidator && (
              <div
                className={
                  'u-marginBottom5gu u-padding2gu u-bgColorWhite u-borderColorNeutralLight u-borderBottom u-borderTop u-borderLeft u-borderRight' +
                  (passwordValid ? ' u-hidden' : '')
                }
                style={{ transform: 'translateY(-36px)' }}
              >
                <PasswordValidator
                  username={username}
                  passwordInput={newPassword}
                  onValidate={onValidatePassword}
                />
              </div>
            )}
            <InputGroup
              formValidation={formValidation}
              fieldName="login-confirm-new-password"
              fieldId="login-confirm-new-password"
              label="Confirm new password"
              handleInputChange={onChangeConfirmPassword}
              compact={false}
              type="password"
              defaultValue={confirmPassword}
              maskedValue={confirmPassword}
            />
            <button
              onClick={submitChangePassword}
              className="Button Button--primary Button--block u-marginBottom4gu u-textNoTransform"
              data-tracking="primary"
            >
              Next
            </button>
          </fieldset>
        </div>
        {showNewUser && (
          <div className="u-sizeFull u-lg-before1of12 u-lg-size5of12 Content">
            <NewUser />
          </div>
        )}
      </div>
    </div>
  )
}

ChangePassword.propTypes = {}

export default ChangePassword
